import { GridRowClickEvent } from "@progress/kendo-react-grid";
import { MenuSelectEvent } from "@progress/kendo-react-layout";
import { router } from "../app/routes";
import { useSharedState } from "../hooks";
import { useCallback } from "react";

export function useGridActions<T>(
  route?: string, 
  clickHandler?: (e: GridRowClickEvent) => void, 
  customParam?:(dataItem: T)=>  Map<string, string>
) {

  const showAddState = useSharedState(false);
  const showEditState = useSharedState(false);
  const showDeleteState = useSharedState(false);
  const showCloneState = useSharedState(false);
  const showInvoiceState = useSharedState(false);
  const showPaymentState = useSharedState(false);

  const editItemState = useSharedState<T>({} as T);
  const deleteItemState = useSharedState<T>({} as T);
  const itemInvoiceState = useSharedState<T>({} as T);
  const paymentDetailsState = useSharedState<T>({} as T);

  const onSelect = (e: MenuSelectEvent, dataItem: any) => {
    switch (e.item.data.action) {
      case "open":
        if(route) {
          router.navigateWithParams(
            route ?? "",
            customParam?.(dataItem) ?? new Map([["id", dataItem.id]])
          );
        }
        else{
          showEdit(dataItem);
        }
        break;
      case "opentab":
        router.navigateWithParams(
          route ?? "",
          customParam?.(dataItem)?? new Map([["id", dataItem.id]]),
          null,
          true
        );
        break;
      case "delete":
        showDelete(dataItem);
        break;
      case "invoice":
        showInvoice(dataItem);
        break;
      case "payment":
        showPaymentDetails(dataItem)
    }
  };

  const onClick = (e: GridRowClickEvent, params?: Map<string, string>) => {
    if(route){
      const routeParams = params ?? new Map([["id", e.dataItem.id]]);
      router.navigateWithParams(
        route ?? "",
        routeParams
      );
    }
    else{
      showEdit(e.dataItem);
    }
  };

  const showEdit = useCallback((dataItem: T) => {
    editItemState.setter(dataItem);
    showEditState.setter(true);
  }, [showEditState, editItemState]);

  const showDelete = useCallback((dataItem: any) => {
    deleteItemState.setter(dataItem);
    showDeleteState.setter(true);
  }, [showDeleteState, deleteItemState]);

  const showInvoice = useCallback((dataItem: any) => {
    itemInvoiceState.setter(dataItem);
    showInvoiceState.setter(true);
  }, [showInvoiceState, itemInvoiceState]);

  const showPaymentDetails = useCallback((dataItem: any) => {
    paymentDetailsState.setter(dataItem);
    showPaymentState.setter(true);
  }, [showPaymentState, paymentDetailsState]);

  return {
    onSelect,
    onClick,
    showDelete,
    showEdit,
    showInvoice,
    showAddState,
    showEditState,
    showDeleteState,
    editItemState,
    deleteItemState,
    showCloneState,
    showInvoiceState,
    itemInvoiceState,
  };
}

export default useGridActions;
